// For Firebase JS SDK v7.20.0 and later, measurementId is optional

import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyAF__3qlOFI-RPSu3QT4KzEotSIhAdAH-Y",
  authDomain: "buygenix-17248.firebaseapp.com",
  projectId: "buygenix-17248",
  storageBucket: "buygenix-17248.appspot.com",
  messagingSenderId: "699964343015",
  appId: "1:699964343015:web:1144ec00ccdc0fa7b31842",
  measurementId: "G-W15XC4ZJM8",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
const auth = firebase.auth();

export { db, auth };
